import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  Box,
} from '@mui/material';
import Warning from '@mui/icons-material/Warning';
import { ALLIANT_BROKER_CODE } from 'common/AppConstant';
import { useSelector } from 'react-redux';

export default function CensusFileReminderDialog({ open, onClose }) {
  const brokerCode = useSelector((state) => state.auth?.brokerCode);
  const validationError = useSelector((state) => state.scenario.validationError);
  const censusFileName = useSelector((state) => state.scenario?.scenario?.censusFileName);
  const handleDialogClose = () => {
    onClose();
  };

  const getCensusFileDetails = () => {
    if (brokerCode === ALLIANT_BROKER_CODE) {
      return {
        fileName: 'census_sampleALNT.csv',
        filePath: '/census_sampleALNT.csv',

      };
    }
    return {
      fileName: 'census_sample.csv',
      filePath: '/census_sample.csv',
    };
  };

  const onCensusSampleDownload = () => {
    const { fileName, filePath } = getCensusFileDetails();
    const link = document.createElement('a');
    link.download = fileName;
    link.href = filePath;
    link.click();
  };

  return (
    <Dialog PaperProps={{ sx: { width: '40%', maxWidth: '70%' } }} open={open}>
      <DialogTitle sx={{ fontSize: '1.25rem', color: 'primary.dark' }}>
        <Warning sx={{ marginBottom: '-5px' }} />
        &nbsp;
        Errors Detected
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ fontSize: '1rem', marginBottom: '1rem' }}>
        <Typography>

          The following errors have been detected in
          {' '}
          {censusFileName}
        </Typography>
        {Array.isArray(validationError) && validationError.length > 0 ? (
          <ul>
            {validationError.map((error) => (
              <li key={error}>
                <Typography>{error}</Typography>
              </li>
            ))}
          </ul>
        ) : null }
        <Typography>
          Update your file and try again. You can also &nbsp;
          <Box
            component="span"
            sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'primary.main' }}
            onClick={onCensusSampleDownload}
          >
            download a template.
          </Box>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleDialogClose}
          variant="contained"
          color="primary"
          autoFocus
        >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
}
